import styled from 'styled-components';

export const SalesTabs = styled.div`
  display: flex;
  flex-wrap: nowrap;
  border-radius: 10px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  max-width: fit-content;
  height: 49px;

  @media (max-width: 1550px) {
    flex-wrap: wrap;
    height: 100px;
  }
  @media (max-width: 550px) {
    flex-wrap: wrap;
    height: auto;
  }
`;

export const ErrorText = styled.legend`
  color: #e63946;
  font-weight: 600;
  display: flex;
  gap: 3px;
  justify-content: end;
  font-size: 12px;
  line-height: 12px;
`;

export const TabButton = styled.button`
  position: relative;
  background: transparent;
  padding: 10px 20px;
  border: none;
  color: ${({ $active }) => ($active ? '#007bff' : 'rgba(108, 117, 125, 1)')};
  font-size: 14px;
  font-weight: 400;
  line-height: 9px;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.2s;
  text-decoration: none;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.9;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: ${({ $active }) => ($active ? '50%' : '0')};
    height: 3px;
    background-color: rgba(45, 108, 223, 1);
    transition: width 0.3s ease;
  }
`;

export const SalesContainer = styled.div`
  padding: 20px;
`;

export const TabContent = styled.div`
  font-size: 24px;
  margin-top: 20px;
`;

export const BtnWrapper = styled.div`
  max-width: 200px;
  margin-right: 20px;
  .h-38 {
    height: 38px;
    font-size: 14px;
    font-weight: 600;
  }
  @media (max-width: 550px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

export const Form = styled.form`
  .color-selector-input {
    top: -320px !important;
  }
`;

export const ShiftControl = styled.div`
  cursor: pointer;
`;

export const EllipsisCell = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: 550px) {
    width: 100px;
  }
`;

export const LeadSourceFilter = styled.div`
  height: 85px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border-radius: 10px;
  margin: 20px 0;
  @media (max-width: 550px) {
    height: auto;
    flex-direction: column;
    margin: 0;
  }
`;

export const LeadFilterBox = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  margin-left: 20px;

  .max-count-title {
    display: none;
  }
  @media (max-width: 550px) {
    flex-direction: column;
    gap: 5px;
    margin: 10px 0;
  }
`;

export const CountPriceCurrencyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`;

export const InputWrapper = styled.div`
  flex: 1;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: 80vh;
`;

export const FilterSelectBox = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    margin: 0;
  }
  > div {
    width: 120px;
    min-height: 0;
  }
  .async-select {
    display: flex;
  }
  @media (max-width: 550px) {
    width: 100%;
    > div {
      width: 100%;
      min-height: 0;
    }
  }
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 22px 0;
  width: 100%;
  justify-content: end;
`;
export const WorkflowSwitch = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: end;
`;
export const Icon = styled.img``;

export const DatePickerWrapper = styled.div`
  height: 80px;
  flex: 1;
`;
